import styled from 'styled-components';

export const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
`;

export const CustomFieldContainer = styled.div`
  padding: 16px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background-color: #f8f9fa;
  position: relative;
`;

export const FieldOptions = styled.div`
  padding: 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background-color: #ffffff;
`;

export const FieldGroup = styled.div`
  padding: 16px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background-color: #ffffff;
  margin-bottom: 16px;
  position: relative;
`;

export const RequiredIndicator = styled.span`
  color: #dc3545;
  margin-left: 4px;
`;
